import * as React from "react"

import { cn } from "@/lib/utils"
import { useGraphite } from "@/components/Graphite"

// Graphite's field, several lines high
const GRAPHITE_TEXTAREA = "flex min-h-[72px] w-full rounded-md border border-input bg-transparent px-2.5 py-1.5 text-[13px] text-foreground placeholder:text-muted-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-40"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  const graphite = useGraphite()
  return (
    <textarea
      className={cn(
        graphite ? GRAPHITE_TEXTAREA : "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
